import script from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceiptForm.vue?vue&type=style&index=0&id=d2817856&scoped=true&lang=css"
import "./MoneyReceiptForm.vue?vue&type=style&index=1&id=d2817856&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2817856"]])

export default __exports__